import { action, makeObservable, observable } from "mobx";
import PlacesApi, { PlacesApi as IPlacesApi } from "../../../../../services/api/v2/places/Places.api";
import { SHOW_MAP_REPORTING } from "./modals/MapReporting_modal";

export class LocationsModel {
  isLoading: boolean;
  placesApi: IPlacesApi;
  organisationId: number;
  @observable locations: [] = [];

  /**
   *
   */
  constructor(organisationId: number) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.placesApi = PlacesApi;
  }

  @action
  onMount = () => {
    this.setLoading(true);
    this.loadPlaces();
    this.setLoading(false);
  };

  @action
  loadPlaces = async () => {
    try {
      const res = await this.placesApi.getAllPlacesForPlaceMap(this.organisationId);
      this.mapToPoi(res.payload);
    } catch (error) {
      console.error(error);
    }
  };

  mapToPoi = locations => {
    let poi = [];
    let duplicatedLocation = new Set();

    locations.forEach(location => {
      const coordKey = `${location.latitude},${location.longitude}`;
      if (!duplicatedLocation.has(coordKey)) {
        duplicatedLocation.add(coordKey);
        poi.push({
          key: location.id,
          name: location.name,
          streetAddress: location.streetAddress,
          city: location.city,
          country: location.country,
          projectNames: location.projectNames,
          totalProjects: location.totalProjects,
          totalImpacts: location.totalImpacts,
          totalProjectProcesses: location.totalProjectProcesses,
          location: {
            lat: location.latitude,
            lng: location.longitude
          }
        });
      }
    });

    this.setLocations(poi);
  };

  @action
  showMapReportingModal = (selectedPlaceId: number) => {
    SHOW_MAP_REPORTING(selectedPlaceId);
  };

  @action
  setLocations = data => {
    this.locations = data;
  };

  @action
  setLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };
}
